import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push, replace} from 'react-router-redux';

import * as defaultStyles from '../../styles';
import {imageUrl} from '../../utilities/requests';
import {request} from '../../containers/actions';
import Dialog from '../../dialog/dialog';
import Summary from './summary';
import Info from './info';
import Delivery from './delivery';
import Payment from './payment';
import Review from './review';
import * as actions from './actions';
import { resizer1100, resizer600, resizer800 } from '../../responsiver';
import * as styles from '../../styles';

//Radium(Cart);
export default class Cart extends React.PureComponent { 
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        is_virtual:'',
        coupon : ''
    }

    componentWillMount() {
        window.renderStoreItem = async uuid => {
            const element = document.getElementById(`store-item-${uuid}`);
            const id = element.querySelector('.store-item-id').innerText;
            if (element.classList.contains('rendered'))
                return;
            if (element.closest('.content.edit'))
                return;
            const item = await this.context.store.dispatch(request({path: `/store-item/${id}/`}));
            if (element.classList.contains('rendered'))
                return;
            const priceTag = document.createElement('div');
            priceTag.innerText = item.price.persian() + ' ' + window.gettext('Tooman');
            element.appendChild(priceTag);
            element.onclick = () => this.context.store.dispatch(actions.addToCart({
                item,
                count: 1,
            }));
            element.classList.add('rendered');
        };

        if (this.props.summary)
            return;
        this.setState({initialized: false});
        const close = event => {
            if (!event.defaultPrevented && this.refs.active && !this.refs.active.contains(event.target))
                this.context.store.dispatch(push({
                    pathname: '/store/purchase/',
                    query: this.props.location.query,
                }));
        };
        window.addEventListener('click', close, true);
        this.cleanUp = () => {
            window.removeEventListener('click', close, true);
        };
        this.fetchPrices();
    }

    componentDidMount() {
        if (this.props.summary)
            return;

        const itemTypes = this.props.store.getIn(['main', 'items']).map(item => item.getIn(['item', 'virtual'])).toSet().toArray();
        const type = this.props.location.query.type
            ? this.props.location.query.type === 'virtual'
            : itemTypes[0];
        this.setState({
            is_virtual : type
        });
        const items = this.props.store.getIn(['main', 'items']).filter(item => item.getIn(['item', 'virtual']) === type);
        this.addressRequired = items.some(item => item.getIn(['item', 'address_required']));

        const initialize = () => {
            if (this.context.store.getState().getIn(['application', 'token', 'accessToken'])) {
                if (!this.state.initialized)
                    this.setState.bind(this)({initialized: true});
            }
            else {
                setTimeout(initialize, 1000);
            }
        };
        setTimeout(initialize, 2500);
        if (this.props.params && this.props.params.page === 'next')
            this.goNext.bind(this)();
        if (!this.context.store.getState().getIn(['application', 'token', 'accessToken']))
            this.context.store.dispatch(push({
                ...this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS(),
                query: {
                    ...this.props.location.query,
                    dialog: 'login',
                    login_message: btoa(unescape(encodeURIComponent(
                        window.gettext('In order to register a purchase you should be logged in.'),
                    ))),
                },
            }));
    }

    componentWillUnmount() {
        if (this.props.summary)
            return;
        this.cleanUp();
    }

    componentWillUpdate(nextProps) {
        if (this.props.summary)
            return;
        if (
            this.props.store.getIn(['main', 'items']) !== nextProps.store.getIn(['main', 'items']) ||
            this.props.location.query.type !== nextProps.location.query.type
        ) {
            const itemTypes = nextProps.store.getIn(['main', 'items']).map(item => item.getIn(['item', 'virtual'])).toSet().toArray();
            const type = nextProps.location.query.type
                ? nextProps.location.query.type === 'virtual'
                : itemTypes[0];
            const items = nextProps.store.getIn(['main', 'items']).filter(item => item.getIn(['item', 'virtual']) === type);
            this.addressRequired = items.some(item => item.getIn(['item', 'address_required']));
        }
        if (
            this.props.params &&
            this.props.params.page !== 'next' &&
            nextProps.params &&
            nextProps.params.page === 'next'
        ) {
            this.goNext.bind(this)();
        }
    }

    async fetchPrices() {
        const response = await this.context.store.dispatch(request({
            path: '/post-price/?limit=1000',
        }));
        this.setState({prices: response.results});
    }

    nextItem() {
        const itemTypes = this.props.store.getIn(['main', 'items']).map(item => item.getIn(['item', 'virtual'])).toSet().toArray();
        const type = this.props.location.query.type
            ? this.props.location.query.type === 'virtual'
            : itemTypes[0];
        const items = [
            {page: '/summary', passed: true},
            {page: '/info', passed: (type && this.props.store.getIn(['cityTree', 'selected']).size > 0 
                                    && this.props.store.getIn(['main', 'info', 'address'])) ||  (
                this.props.store.getIn(['main', 'info', 'firstname']) &&
                this.props.store.getIn(['main', 'info', 'lastname']) &&
                this.props.store.getIn(['main', 'info', 'cell_phone']) &&
                (!this.addressRequired || this.props.store.getIn(['main', 'info', 'address'])) &&
                this.props.store.getIn(['cityTree', 'selected']).size > 0
            )},
            ...type ? [] : [{page: '/delivery', passed: type || this.props.store.getIn(['main', 'delivery_method']) !== null}],
            ...type ? [] : [{page: '/payment', passed: type || this.props.store.getIn(['main', 'payment_method']) !== null}],
            {page: '', passed: false},
        ];
        let result;
        _.forEach(items, (item, index) => {
            if (!item.passed) {
                result = {page: item.page, index};
                return false;
            }
            return true;
        });
        return result;
    }

    goNext() {
        this.context.store.dispatch(push({
            pathname: `/store/purchase${this.nextItem.bind(this)().page}/`,
            query: this.props.location.query,
        }));
    }

    render() {
        const itemTypes = this.props.store.getIn(['main', 'items']).map(item => item.getIn(['item', 'virtual'])).toSet().toArray();
        const type = this.props.location && this.props.location.query.type
            ? this.props.location.query.type === 'virtual'
            : itemTypes[0];
        if (this.props.summary)
            return <Summary {...this.props}/>;
        const items = this.props.store.getIn(['main', 'items']).filter(item => item.getIn(['item', 'virtual']) === type);
        const weight = items.reduce(
            (sum, item) => sum + item.getIn(['item', 'weight']) * item.get('count'),
            0,
        );
        const types = _.uniq(_.map(this.state.prices, 'type'));
        const regionId = this.props.store.getIn(['regionTree', 'selected']).keySeq()[0];
        const regionStatus = regionId === 110791
            ? 'same'
            : _.includes([7648907, 443794, 124544, 124763, 116401])
                ? 'neighbor'
                : 'far';
        const deliveryPrices = regionStatus
            ? _.mapValues(
                _.mapKeys(types, type => type),
                type => {
                    const match = _.filter(
                        this.state.prices,
                        row => row.type === type && row.froM <= weight && row.to >= weight,
                    )[0];
                    if (match)
                        return match['price_' + regionStatus];
                    else
                        return null;
                },
            )
            : {};
        const height = 35;
        const nextIndex = this.nextItem.bind(this)().index;
        const steps = [
            {
                component: Summary,
                page: 'summary',
                label: window.gettext('Cart'),
                icon: 'shopping-basket',
                passed: true,
            },
            {
                component: Info,
                page: 'info',
                label: type ? 'اطلاعات تکمیلی' : window.gettext('Recipient Info'),
                icon: 'envelope-o',
                passed: (type && this.props.store.getIn(['cityTree', 'selected']).size > 0 && this.props.store.getIn(['main', 'info', 'address'])) ||  (
                    this.props.store.getIn(['main', 'info', 'firstname']) &&
                    this.props.store.getIn(['main', 'info', 'lastname']) &&
                    this.props.store.getIn(['main', 'info', 'cell_phone']) &&
                    (!this.addressRequired || this.props.store.getIn(['main', 'info', 'address'])) &&
                    this.props.store.getIn(['cityTree', 'selected']).size > 0
                ), 
            },
            {
                component: Delivery,
                page: 'delivery',
                label: window.gettext('Delivery Method'),
                icon: 'truck',
                passed: type || this.props.store.getIn(['main', 'delivery_method']) !== null,
                disabled: type,
            },
            {
                component: Payment,
                page: 'payment',
                label: window.gettext('Payment Method'),
                icon: 'credit-card',
                passed: this.props.store.getIn(['main', 'payment_method']) !== null,
            },
        ];
        const allPassed = (
            _.every(steps.slice(0, 4), step => step.passed) &&
            items.size &&
            items.every(item => item.get('count') > 0)
        );
        return <div style={resizer1100}>
            <Dialog isOpen={this.state.connectingBank}>
                <div>{window.gettext('Connecting to Bank')}...</div>
            </Dialog>
            <div
                style={{
                    float: 'right',
                    position: 'relative',
                    width: '9em',
                    height: '37em',
                }}>
                {this.context.store.getState().getIn(['application', 'token', 'accessToken'])
                    ? _.map(
                        _.filter(steps, step => !step.disabled),
                        (step, index) => {
                            const available = _.every(Array(index), (__, index) => steps[index].passed);
                            const active = this.props.params.page === step.page && this.state.initialized;
                            return <div
                                ref={active ? 'active' : undefined}
                                key={step.page}
                                style={{
                                    position: 'absolute',
                                    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                                    padding: '.5em',
                                    boxSizing: 'border-box',
                                    borderRadius: '.2em',
                                    ...(active
                                        ? {
                                            transition: this.props.params.page ? 'all 300ms 600ms' : 'all 300ms',
                                            top: '.5em',
                                            right: '30.25em',
                                            width: '26em',
                                            height: '39em',
                                            backgroundColor: 'white',
                                            zIndex: '50',
                                        }
                                        : {
                                            transition: 'all 300ms',
                                            top: `${index * 9}em`,
                                            right: '1em',
                                            transform: 'translateY(0)',
                                            width: '8em',
                                            height: '8em',
                                            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                                            backgroundColor: step.passed ? 'rgb(213, 255, 222)' : available
                                                ? 'white'
                                                : '#efefef',
                                            cursor: (available || step.passed) ? 'pointer' : 'not-allowed',
                                            zIndex: '0',
                                        }),
                                }}
                                onClick={() => {
                                    if (!active && (available || step.passed))
                                        this.context.store.dispatch(push({
                                            pathname: `/store/purchase/${step.page}/`,
                                            query: this.props.location.query,
                                        }));
                                }}>
                                <div
                                    style={{
                                        position: 'relative',
                                        borderBottom: active ? '.0625em solid #9a9a9a' : '0 solid black',
                                        color: available ? 'black' : defaultStyles.disabledColor,
                                        padding: '.3em',
                                        marginBottom: '.5em',
                                        transition: active ? 'border 300ms 900ms' : 'border 300ms',
                                        textAlign: 'center',
                                    }}>
                                    {step.label}
                                    <i
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            left: '.5em',
                                            cursor: 'pointer',
                                            float: 'left',
                                            opacity: active ? '1' : '0',
                                            transition: active ? 'opacity 300ms 900ms' : 'opacity 300ms',
                                            color: 'black',
                                        }}
                                        className='fa-times fa-lg'
                                        onClick={() => this.context.store.dispatch(push({
                                            pathname: '/store/purchase/',
                                            query: this.props.location.query,
                                        }))}>
                                    </i>
                                </div>
                                <div
                                    style={{
                                        height: active ? 'calc(100% - 2.9em/.9)' : '0',
                                        overflow: active ? undefined : 'hidden',
                                        fontSize: '.9em',
                                        opacity: active ? '1' : '0',
                                        transition: active
                                            ? 'opacity 300ms 900ms, height 0ms 900ms'
                                            : 'opacity 300ms, height 0ms',
                                    }}>
                                    <step.component {...this.props}
                                        active
                                        deliveryPrices={deliveryPrices}
                                        addressRequired={this.addressRequired}
                                        is_virtual = {this.state.is_virtual}
                                    />
                                </div>
                                <div
                                    style={{
                                        animation: index === nextIndex
                                            ? 'x 700ms ease-in 0s infinite alternate'
                                            : undefined,
                                        animationName: index === nextIndex
                                            ? Radium.keyframes({
                                                '0%': {color: 'rgba(240, 0, 0, .77)'},
                                                '100%': {color: 'black'},
                                            })
                                            : undefined,
                                        maxHeight: active ? '0' : '20em',
                                        opacity: active ? '0' : '1',
                                        transition: active
                                            ? 'opacity 0ms 700ms, max-height 0ms 700ms'
                                            : 'opacity 0ms 200ms, max-height 0ms 200ms',
                                        overflow: 'hidden',
                                        width: '100%',
                                        textAlign: 'center',
                                    }}>
                                    <i className={`fa fa-${step.icon} fa-3x`}></i>
                                </div>
                            </div>;
                        },
                    )
                    : null
                }
            </div>
            <div
                style={{
                    position: 'relative',
                    float: 'right',
                    width: 'calc(100% - 14em)',
                    marginRight: '2.5em',
                    borderRadius: '.2em',
                    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                    height: `${height}em`,
                }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        width: '100%',
                        height: '100%',
                        backgroundColor: this.props.params.page
                            ? 'rgba(60, 60, 60, .88)'
                            : 'rgba(100, 100, 100, 0)',
                        transition: 'background-color 400ms 600ms',
                        pointerEvents: this.props.params.page ? undefined : 'none',
                        zIndex: '10',
                    }}>
                </div>
                <Review
                    store={this.props.store.get('main')}
                    items={items}
                    prices={this.state.prices}
                    sections={steps}
                    weight={weight}
                    deliveryPrices={deliveryPrices}
                    is_virtual = {this.state.is_virtual}

                />
                <div style={{float: 'left'}}>
                    {allPassed
                        ? <div
                            style={{
                                position: 'absolute',
                                bottom: '2em',
                                right: '26.5em',
                            }}>
                            {window.gettext('Final price')}:
                            &nbsp;
                            <span style={{fontWeight: '700'}}>
                                {(items.reduce(
                                    (sum, item) => sum + (item.getIn(['item', 'price']) - (item.getIn(['item', 'price']) * item.getIn(['item', 'off']) / 100)) * item.get('count'), 
                                    0,
                                ) + ((!this.state.is_virtual && deliveryPrices[this.props.store.getIn(['main', 'delivery_method'])]) || 0)).persian()} {window.gettext('Tooman')}
                            </span>
                        </div>
                        : null
                    }
                    <label
                        htmlFor='mellat'
                        style={{
                            ...defaultStyles.button,
                            position: 'absolute',
                            bottom: '2em',
                            left: '9em',
                            display: allPassed && this.props.store.getIn(['main', 'payment_method']) === 0 ? 'flex' : 'none',
                            flexFlow: 'column',
                            alignItems: 'center',
                            marginBottom: '1em',
                            marginBottom: '0',
                            padding: '.1em',
                            minWidth: undefined,
                        }}>
                        <img
                            src={imageUrl(window.images.mellat, {
                                width: 75,
                                type: 'contain',
                            })}
                        />
                        <input
                            style={{marginTop: '-.75em'}}
                            id='mellat'
                            type='radio'
                            defaultChecked
                        />
                    </label>
                    {
                        !this.state.is_virtual ? 
                        <div>
                             <div                                
                                style={{marginRight: '.5em',
                                marginTop: '0', 
                                marginBottom: '-.25em', 
                                position: 'relative',
                                left:'80%'
                                }}>
                                کد تخفیف :
                                <input
                                    key='coupon'
                                    containerStyle={{width: '100%'}}
                                    style={styles.numberField}
                                    value={(this.state.coupon || '').persian()}
                                    onChange={({target: {value}}) => this.setState({
                                        coupon: value.english()
                                    })}
                                /> 
                            </div>
                        </div> : null
                    }
                    <button
                        style={{
                            ...defaultStyles.button,
                            position: 'absolute',
                            bottom: '2em',
                            left: '2em',
                            cursor: allPassed ? 'pointer' : 'not-allowed',
                            backgroundColor: allPassed ? 'green' : undefined,
                            borderTop: allPassed ? '.0625em solid green' : 'none',
                            borderBottom: allPassed ? '.0625em solid green' : 'none',
                            borderLeft: allPassed ? '.0625em solid green' : 'none',
                            borderRight: allPassed ? '.0625em solid green' : 'none',
                            borderRadius: '.2em',
                            animation: allPassed ? 'x 700ms ease-in 0s infinite alternate' : undefined,
                            animationName: allPassed
                                ? Radium.keyframes({
                                    '0%': {backgroundColor: '#a9a9a9'},
                                    '100%': {backgroundColor: '#a9fda9'},
                                })
                                : undefined,
                        }}
                        onClick={async () => {
                            if (!allPassed)
                                return;
                            if (this.props.store.getIn(['main', 'payment_method']) === 0)
                                this.setState({connectingBank: true});
                            let response;
                            try {
                                response = await this.context.store.dispatch(request({
                                    path: '/order/purchase/',
                                    body: this.props.store.getIn(['main', 'info']).merge({
                                        delivery_method: this.state.is_virtual ? null : this.props.store.getIn(['main', 'delivery_method']),
                                        payment_method: this.props.store.getIn(['main', 'payment_method']),
                                        coupon:this.state.coupon,
                                        items: items.toArray(),
                                    }).toJS(),
                                    metohd: 'POST',
                                }));
                            }
                            catch (exception) {
                                this.setState({connectingBank: false});
                                return;
                            }
                            await this.context.store.dispatch(actions.clearCart(type));
                            if (response.payment_id) {
                                // if (process.env.NODE_ENV !== 'production') {
                                //     window.location.reload();
                                //     return;
                                // }
                                
                                const form = document.createElement('form');
                                form.action = response.payment_id;
                                form.method = 'Get';
                                form.target = '_self';
                                const refId = document.createElement('input'); 
                                refId.value = response.payment_id; 
                                document.body.appendChild(form);
                                form.submit();
                            }
                            else if (response.id) {
                                await this.context.store.dispatch(push(
                                    `/store/orders/${response.id}/?first_visit=true`,
                                ));
                                const location = this.context.store.getState().get('routing').
                                    get('locationBeforeTransitions').toJS();
                                this.context.store.dispatch(replace(location));
                            }
                        }}>
                        {window.gettext('Final Confirmation')}
                    </button>
                </div>
            </div>
        </div>;
    }
}
